export const OidcSettings = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  post_logout_redirect_uri: `${window.location.origin +
    process.env.REACT_APP_SUB_FOLDER}/login`,
  redirect_uri: `${window.location.origin + process.env.REACT_APP_SUB_FOLDER}/`,
  response_type: "id_token token",
  revokeAccessTokenOnSignout: true,
  scope: "openid profile opa-cd-api email"
};
